import PropTypes from "prop-types";

export const shiftFilterTitleInterface = {
  shiftTitleIndex: PropTypes.number,
  filterValue: PropTypes.object.isRequired,
  elementIndex: PropTypes.number,
  positionTop: PropTypes.number,
  columnPosition: PropTypes.number,
  type: PropTypes.string
};
